import React from 'react';
import ServiceDetailPage from '../../components/ServiceDetailPage';
import EmailFlow from './EmailFlow';
import emailBannerImage from './assets/email-banner.jpeg';

const EmailMarketing = () => {
  return (
    <>
      <ServiceDetailPage
        pageTitle="Email Marketing"
        breadcrumbLabel="Email"
        lead="Run high-deliverability email campaigns with full performance tracking."
        paragraphs={[
          'Create and schedule promotional, transactional, and drip campaigns with segmentation and template support.',
          'Track opens, clicks, bounce handling, and audience behavior in real time to improve campaign ROI.',
          'From list import to deliverability setup, the platform gives your team end-to-end control.'
        ]}
        benefits={[
          'Bulk sending with inbox-focused setup',
          'Audience segmentation and A/B testing',
          'Live analytics and reporting dashboard',
          'API support for triggered email flows'
        ]}
        heroImage={emailBannerImage}
        ctaText="Start Email Campaign"
        ctaHref="/contact"
      />
      <EmailFlow />
    </>
  );
};

export default EmailMarketing;